import { render, staticRenderFns } from "./FabricNameFields.vue?vue&type=template&id=fc546004&scoped=true&"
import script from "./FabricNameFields.vue?vue&type=script&lang=ts&"
export * from "./FabricNameFields.vue?vue&type=script&lang=ts&"
import style0 from "./FabricNameFields.vue?vue&type=style&index=0&id=fc546004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc546004",
  null
  
)

export default component.exports